/**
 * GEO_LOCATION const symbols.
 * @constant
 * @type {Object}
 */


export const GEO_LOCATION = {
    NUN: 0,
    GEO_HYBRID_ANDROID: 'HYBRID_ANDROID',
    GEO_HYBRID_IOS: 'HYBRID_IOS',
    GEO_WEBAPP_ANDROID: 'WEBAPP_ANDROID',
    GEO_WEBAPP_IOS: 'WEBAPP_IOS',
    GEO_PC: 'PC',
    GEO_MAC: 'MAC',
    RES_OK: '1',
    RES_FAILED: '0',
    USER_ID: 'userId',
    REASON: 'reason',
    PHONE: 'phone',
    LICENSE: 'license',
    SESSION_KEY: 'sessionKey',
    REASON_LOGIN: 'Login',
    REASON_OPEN_REAL_GAME: 'OPEN_REAL_GAME',
    REASON_PERIODIC: 'Periodic',
    USER_ID_OK: 1,
    REASON_OK: 2,
    PHONE_OK: 4,
    LICENSE_OK: 8,
    SESSION_KEY_OK: 16,
    ALL_DATA_OK: 31,
    WIN: 'win',
    MAC: 'mac',
    GC_PLATFORM: '{{GC_PLATFORM}}',
    GC_VERSION: '{{GC_VERSION}}',
    GC_DOWNLOAD_PAGE: '{{GC_DOWNLOAD_PAGE}}',
    GC_KEY: '{{GC_KEY}}',
    GC_BROWSER: '{{GC_BROWSER}}',
    PLUGIN_NOT_UPDATED_ERROR: '615',
    ANTI_LOOP_DELAY: 10000,
    PLUGIN_INSTALLATION_MSG_TXT: 'geo_plugin_installation_msg_txt',
    PLUGIN_INSTALLATION_MSG_TITLE: 'geo_plugin_installation_msg_title',
    PLUGIN_INSTALLATION_MSG_INSTALL_BTN: 'Geo_Install',
    OOBEE_HINT_TITLE: 'Oobee_hint_title',
    OOBEE_HINT_TXT: 'Oobee_hint_txt',
    OOBEE_HINT_INSTALL: 'Oobee_hint_install',
    OOBEE_HINT_WAKEUP: 'Oobee_hint_wakeup',
    GA_GEO_START_GEO_PROCESS: 'Start Geo Process',
    GA_GEO_PLUGIN_ENABLE: 'GeoLocation plugin enable',
    GA_GEO_LOCATION_REQUEST_SENT: 'GeoLocation request for geo comply sent',
    GA_GEO_LOCATION_VALIDATION: 'GeoLocation send platform the token received from geo comply',
    GA_GEO_LOCATION_FAIL_VALIDATE_GEO_LOCATION: 'GeoLocation Failed ValidateGeoLocation from platform(location manager)',
    GA_GEO_LOCATION_FAIL_TIMEOUT_ON_UPDATING_RESTRICTIONS: 'GeoLocation remove the geo popup because failed timeout on updating restrictions.',
    GA_GEO_LOCATION_SUCCEEDED_VALIDATE_GEO_LOCATION: 'GeoLocation ok response from ValidateGeoLocation api from platform(location manager)',
    GA_GEO_LOCATION_POPUP_CLOSED: 'Geolocation in progress popup closed',
    GA_GEO_LOCATION_RESET_WAITING_FOR_RESPONSE: 'GeoLocation Reset waitingForResponse from geo comply by timeout',
    GA_GEO_LOCATION_CATEGORY_SERVICE: 'GeoLocation Service',
    GA_GEO_LOCATION_CATEGORY_WRAPPER: 'GeoLocation',
    GA_GEO_LOCATION_KICK_EVENT: 'onGeoKickEvent',
    GA_GEO_DISABLED: 'GeoLocation feature disabled',
    GA_IS_GEO_LOCATION_IN_PROCESS_FALSE: 'GeoLocation - no need for Geo now isGeoLocationInProcess it true',
    GA_GEO_PLATFORM_ASK_GEO_VIA_LOGIN: 'Platform ask geo process via login property',
    GA_GEO_NOT_VALID_REQUEST_FROM_PLATFORM: 'invalid request from platform for geo check',
    TECHNICAL_PROBLEM_REASON: 'kick_reason_26',
    GEO_IN_PROCESS_MSG_TITLE: 'geo_location_title',
    GENERIC_OK_BUTTON: 'mdp_ok',
    GA_GEO_CLEAN_GEO_LOGIN_PROPERTY: 'GeoLocation Clean geoLocation property from login token',
    GA_GEO_SHOW_GEO_IN_PROGRESS_POPUP: 'GeoLocation show geo in progress popup',
    GA_GEO_GEO_COMPLY_RESULT_OK: 'GeoLocation geo comply result is ok',
    GA_GEO_GEO_COMPLY_RESULT_FAILED : 'GeoLocation geo comply result failed'
};